module.exports = __webpack_public_path__ + "img/booksAfter5.8851ba73.jpg";